import { EpgViewConfig, SidebarConfig } from '../src/types';

export const defaultEpgViewConfig: EpgViewConfig = {
    pixelsPerMin: 10,
    currentTimeUpdateInterval: 60,
    visibleChunkSizeViewports: 2,
};

export const sidebarConfig: SidebarConfig = {
    sidebarWidthMobile: 88,
};
